/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is a good Flesch Reading Ease score?`)
};

const es_ra_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cuál es una buena puntuación Flesch Reading Ease?`)
};

const de_ra_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was ist ein guter Flesch Reading Ease-Wert?`)
};

const nl_ra_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wat is een goede Flesch Reading Ease-score?`)
};

const fr_ra_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quel est un bon score Flesch Reading Ease ?`)
};

const it_ra_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual è un buon punteggio Flesch Reading Ease?`)
};

const pt_br2_ra_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que é uma boa pontuação de Flesch Reading Ease?`)
};

const pt_ra_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual é uma boa pontuação Flesch Reading Ease?`)
};

const ja_ra_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`良いFlesch Reading Easeスコアとは何ですか？`)
};

const zh_ra_faq1_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Flesch Reading Ease 分数多少算好？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_faq1_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_faq1_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_faq1_q", locale)
	if (locale === "en") return en_ra_faq1_q(inputs)
	if (locale === "es") return es_ra_faq1_q(inputs)
	if (locale === "de") return de_ra_faq1_q(inputs)
	if (locale === "nl") return nl_ra_faq1_q(inputs)
	if (locale === "fr") return fr_ra_faq1_q(inputs)
	if (locale === "it") return it_ra_faq1_q(inputs)
	if (locale === "pt-BR") return pt_br2_ra_faq1_q(inputs)
	if (locale === "pt") return pt_ra_faq1_q(inputs)
	if (locale === "ja") return ja_ra_faq1_q(inputs)
	return zh_ra_faq1_q(inputs)
};